/**
 * Legacy sticker exports — thin aliases onto quiet ui/ primitives.
 * Prefer importing from `components/ui` in new code.
 */
import React from "react";
import Button from "./ui/Button";
import Card from "./ui/Card";
import Badge, { PillToggle as UiPillToggle } from "./ui/Badge";

export { CountBadge } from "./ui/Badge";

/** Subtle secondary button for colorful hero cards (pairs with primary amber CTAs). */
export function HeroSecondaryButton({
  children,
  size = "md",
  type = "button",
  onClick,
  disabled,
  className = "",
  ...rest
}) {
  return (
    <Button
      variant="glass"
      size={size}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      {...rest}
    >
      {children}
    </Button>
  );
}

/** @deprecated Prefer Button from components/ui */
export function StickerButton({
  children,
  color = "amber",
  size = "md",
  type = "button",
  onClick,
  disabled,
  className = "",
  ...rest
}) {
  const variantMap = {
    amber: "primary",
    accent: "primary",
    primary: "night",
    night: "night",
    pink: "secondary",
    purple: "secondary",
    sky: "secondary",
    white: "secondary",
    ink: "night",
  };
  return (
    <Button
      variant={variantMap[color] || "primary"}
      size={size}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      {...rest}
    >
      {children}
    </Button>
  );
}

/** @deprecated Prefer Card from components/ui */
export function StickerCard({ children, color = "white", className = "", hero = false, style, ...rest }) {
  return (
    <Card hero={hero} color={color} className={className} style={style} {...rest}>
      {children}
    </Card>
  );
}

/** @deprecated Prefer Badge from components/ui */
export function Chip({ children, color = "amber", tilt = 0, ghost = false, className = "", ...rest }) {
  return (
    <Badge color={color} tilt={tilt} ghost={ghost} className={className} {...rest}>
      {children}
    </Badge>
  );
}

/** @deprecated Prefer PillToggle from components/ui */
export function PillToggle(props) {
  return <UiPillToggle {...props} />;
}

/** Quiet workflow surface — same as Card */
export function ReadableCard({ children, className = "", ...rest }) {
  return (
    <Card className={className} {...rest}>
      {children}
    </Card>
  );
}

/**
 * Horizontal padding for product top-nav actions.
 * Keep default Button `md` height (44px) — do not pair with `compact` or `h-*` / `min-h-*` overrides.
 */
export const navActionClass = "px-3";

/** Quiet nav / toolbar control — maps onto Button */
export function ReadableNavButton({
  children,
  className = "",
  variant = "default",
  compact = false,
  as: Tag = "button",
  ...rest
}) {
  const variantMap = {
    default: "secondary",
    primary: "primary",
    night: "night",
    danger: "danger",
    dangerOutline: "dangerOutline",
    glass: "glass",
  };
  return (
    <Button
      as={Tag}
      variant={variantMap[variant] || "secondary"}
      compact={compact}
      className={className}
      {...rest}
    >
      {children}
    </Button>
  );
}

/** @deprecated Decorative scallop retired — renders nothing */
export function ScallopDivider() {
  return null;
}
